// main.js
import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import cx from "classnames";

export default class PieChart extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let {width, height, radius, values, colorClasses, strokeWidth} = this.props;
        height = height || width;
        radius = radius || (width - strokeWidth * 2) / 2;
        var total = _.reduce(values, (sum, v) => {return sum + v[0]}, 0); 
        return (
            <svg width={width} height={height} className="wdp-pie-chart wdp-pie-chart-animate" shapeRendering="geometricPrecision">

                {values.map((item, i) => {
                    var left = _.chain(values).take(i).reduce((sum, v) => sum + v[0], 0).value();
                    var leftInDeg = left * 360 / total;

                    var startingAngle = -90;
                    var additionalProps = item[2] || {}
                    return [
                        <circle  key={i} cx={width/2} cy={height/2} r={radius}
                            strokeLinecap="round"
                            className={cx("wdp-pie-arc", "wdp-pie-arc-" + i)}
                            fill="transparent"
                            style={{
                                transform: 'rotate(' + (startingAngle + leftInDeg) + 'deg)'

                            }}
                            strokeDasharray={(item[0] * 360 / total)  + " " +  360}
                            strokeWidth={strokeWidth}
                            {...additionalProps}
                            />,
                    ]
                })}


            </svg>
        )
    }
}
PieChart.defaultProps = {
    width: 120,
    height: 120,
    strokeWidth: 10,
    values: [
        [60, "33%"],
        [10, "33%"],
        [40, "33%"]
    ],
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/PieChart.js
 **/